module.exports = __webpack_public_path__ + "Assets/aok-icons-functional.8f9749b8.ttf";